module.exports = __webpack_public_path__ + "static/media/school_9.88c50c6e.png";